import { useRef } from "react";

type LockerverseResourceIdentity = {
  apiBaseUrl: string | undefined;
  communitySlug: string;
  mediaBaseUrl?: string | undefined;
  environment: string | undefined;
  slug: string;
};

function hasSameIdentity(
  initial: LockerverseResourceIdentity,
  current: LockerverseResourceIdentity
) {
  return (
    initial.apiBaseUrl === current.apiBaseUrl &&
    initial.communitySlug === current.communitySlug &&
    initial.mediaBaseUrl === current.mediaBaseUrl &&
    initial.environment === current.environment &&
    initial.slug === current.slug
  );
}

export function useImmutableResourceIdentity(
  resource: "payment widget" | "signup" | "auctions" | "auction",
  identity: LockerverseResourceIdentity
) {
  const initial = useRef(identity);
  if (!hasSameIdentity(initial.current, identity)) {
    throw new TypeError(
      `Lockerverse ${resource} identity cannot change after initialization. Remount with a new React key.`
    );
  }
}
